import React from "react";
import { useSelector, useDispatch } from "react-redux";
import clsx from "clsx";
import { SnackbarContent, IconButton, Snackbar } from "@material-ui/core";
import { closeSnackbar } from "../../actions/index";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";
import { makeStyles } from "@material-ui/core/styles";
import { amber, green, lightBlue } from "@material-ui/core/colors";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};
const useStylesContent = makeStyles(theme => ({
  success: {
    backgroundColor: theme.palette.type === "dark" ? green["A200"] : green[400]
  },
  error: {
    backgroundColor: theme.palette.error.main
  },
  info: {
    backgroundColor:
      theme.palette.type === "dark" ? lightBlue["A200"] : lightBlue[400]
  },
  warning: {
    backgroundColor: theme.palette.type === "dark" ? amber["A200"] : amber[400]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
}));
const useStylesSnack = makeStyles(theme => ({
  margin: {
    margin: theme.spacing(1)
  }
}));

const UserInteraction = () => {
  const interaction = useSelector(state => state.userInteraction);
  const dispatch = useDispatch();
  const classesContent = useStylesContent();
  const classesSnack = useStylesSnack();
  const Icon = variantIcon[interaction.type];
  return (
    <Snackbar
      onClose={() => dispatch(closeSnackbar())}
      open={interaction.display}
    >
      <SnackbarContent
        className={clsx(classesContent[interaction.type], classesSnack.margin)}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classesContent.message}>
            <Icon
              className={clsx(classesContent.icon, classesContent.iconVariant)}
            />
            {interaction.message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={() => dispatch(closeSnackbar())}
          >
            <CloseIcon className={classesContent.icon} />
          </IconButton>
        ]}
      />
    </Snackbar>
  );
};

export default UserInteraction;
